<template>
    <row>
        <div class="col-xl-12 col-md-12 p-4">
            <p class="text-primary" style="margin-bottom: 0;">
                {{blueTitle}}
            </p>
            <h2 style="margin-top: 0;">{{mainTitle}}<br>
                <small>{{subTitle}}</small>
            </h2>
        </div>
    </row>
</template>

<script>
    import Row from "@/components/Row";
    export default {
        name: "HeaderTitles",
        components: {Row},
        props: ['blueTitle', 'mainTitle', 'subTitle']
    }
</script>

<style scoped>

</style>